<template>
  <div class="tw-w-full">
    <div ref="target" class="tw-flex tw-w-full tw-justify-between">
      <div class="tw-flex">
        <component
          :is="option.to ? 'base-link' : 'button'"
          v-for="(option, index) in options"
          :key="index"
          :to="option.to || null"
          :link-primary="false"
          class="tw-group hover:game-active-button-color-hover tw-py-4 tw-px-2 xs:tw-px-4 tw-flex tw-justify-center tw-items-center tw-relative tw-outline-none tw-text-h6 tw-leading-tight tw-whitespace-nowrap tw-button-transition tw-group"
          :class="Classes.TAB"
          :tabindex="isActive(index) ? '-1' : '0'"
          @click="updateTab($event, option)"
        >
          <font-awesome-icon
            v-if="!option.to && option.icon"
            class="tw-mr-2"
            :icon="option.icon"
          />
          <span
            class="tw-font-bold tw-transition-all group-hover:game-active-text-hover"
            :class="linkClass(index)"
          >
            {{ option.text }}
          </span>
          <div
            v-if="option.count"
            class="tw-flex tw-justify-center tw-items-center game-primary-button-color game-primary-text tw-font-bold tw-text-sm tw-ml-1 tw-h-5 tw-w-5 tw-rounded-full tw-translate-y-px"
          >
            {{ option.count }}
          </div>
          <div
            class="tw-absolute tw-inset-x-0 tw-h-0.5 game-primary-button-color -tw-bottom-0.5"
            :class="isActive(index) ? 'tw-opacity-100' : 'tw-opacity-0'"
            style="margin-left: 0px"
          />
        </component>
        <slot name="after" />
      </div>
      <slot />
    </div>
    <div class="tw-h-0.5 game-tile-background-color" />
  </div>
</template>

<script>
import { toRefs, ref, watchEffect } from 'vue'
import Classes from '@config/css.js'

export default {
  props: {
    modelValue: {
      type: [String, Number],
      default: null,
    },
    options: {
      type: Array,
      required: true,
    },
  },
  emits: ['input'],
  setup(props, { emit }) {
    const { modelValue, options } = toRefs(props)
    const target = ref(null)

    function isActive(index) {
      return (
        options.value.findIndex((o) => o.value === modelValue.value) === index
      )
    }

    function linkClass(index) {
      if (isActive(index)) {
        return ''
      }
      return 'tw-opacity-75 group-hover:tw-opacity-100'
    }

    function updateTab(e, option) {
      emit('input', e, option.value)
    }

    watchEffect(() => {
      if (target.value && options.value?.length) {
        for (let i in options.value) {
          if (isActive(i)) {
            target.value.children[i]?.scrollIntoView({
              behavior: 'smooth',
              block: 'nearest',
              inline: 'center',
            })
            return
          }
        }
      }
    })

    return {
      linkClass,
      updateTab,
      isActive,
      Classes,
      target,
    }
  },
}
</script>
